import { Navigate } from 'react-router-dom';
import { isLoginArea } from '../utils';

function PrivateRouteMedico({ children }) {
    const logok = isLoginArea('medico');

    return logok ? children : <Navigate to="/AreaMedico/Login" />;
}

export default PrivateRouteMedico;
